import { render, staticRenderFns } from "./PostFull.vue?vue&type=template&id=2a88361a&"
import script from "./PostFull.vue?vue&type=script&lang=js&"
export * from "./PostFull.vue?vue&type=script&lang=js&"
import style0 from "./PostFull.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports